import React from 'react';

/**
 * Bluebox Ext.LoadMask overlay for Extra school panel / Extra tab
 * when Question1 cannot resolve a single covering contract.
 */
const AfasQuestion1Mask = ({ message, children, className = '' }) => {
    const show = Boolean(message);

    return (
        <div
            className={[
                'afas-question1-mask-host',
                show ? 'afas-question1-mask-host--active' : '',
                className,
            ]
                .filter(Boolean)
                .join(' ')}
        >
            {children}
            {show ? (
                <div className="afas-question1-mask" role="alert" aria-live="polite">
                    <div className="afas-question1-mask__msg">
                        {String(message)
                            .split('\n')
                            .map((line, index) => (
                                <span key={`${index}-${line}`}>
                                    {index > 0 ? <br /> : null}
                                    {line}
                                </span>
                            ))}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default AfasQuestion1Mask;
